import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { BUTTON_WIDTH } from 'src/config/styles'

import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    height: '100%',
  },
  ctaText: {
    textAlign: 'center',
    ...typography['Lato Body 1'],
  },
  ctaButtonContainer: {
    marginTop: 16,
    textAlign: 'center',
  },
  ctaButton: {
    width: BUTTON_WIDTH,
    [forPhoneOnly]: {
      width: '100%',
    },
  },
  additionalText: {
    marginTop: 16,
    textAlign: 'center',
    ...typography['Lato Body 2'],
    '& a': {
      ...typography['Lato Link 2'],
      color: theme.palette.primary.main,
    },
  },
}))
